<template>
  <transition name="fade">
    <div class="vue-modal" v-show="open">
      <transition name="drop-in">
        <div class="vue-modal-inner" v-show="open" :style="'width:' + width">
          <div class="vue-modal-content">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
//import { onMounted, onBeforeUnmount } from "vue";

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      required: false,
    },
  },
  setup(_, { emit }) {
    const close = () => {
      emit("close");
    };
    /*
    const handleKeyup = (event) => {
      if (event.keyCode === 27) {
        close();
      }
    };
*/
    ////   onMounted(() => document.addEventListener("keyup", handleKeyup));

    // onBeforeUnmount(() => document.removeEventListener("keyup", handleKeyup));

    return {
      close,
    };
  },
};
</script>

<style scoped>
*,
::before,
::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.vue-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2000;
}

.vue-modal-inner {
  width: 350px;
  margin-top: 30rem;
  margin-left: 2rem;
}

.vue-modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
  border-radius: 0.3rem;
  padding: 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
  transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
@media (min-width: 992px) and (max-width: 1200px) {
  .vue-modal-inner {
    margin-top: 25rem;
  }
}
</style>